<div class="admin-bar">Admin — Editor de livros</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <h1>Editor de livros</h1>
    <p class="subtitle">Edite qualquer campo de qualquer livro — alterações são aplicadas imediatamente.</p>

    <!-- Filtros -->
    <form class="filters" [formGroup]="form" (ngSubmit)="applyFilters()">

      <div class="range">
        <div class="range-col">
          <span class="range-label">Busca</span>
          <div class="range-row">
            <mat-form-field appearance="outline" class="field">
              <mat-label>Nome do livro ou autor</mat-label>
              <input matInput formControlName="search" placeholder="Pesquisar..." />
            </mat-form-field>
          </div>
        </div>

        <div class="range-col">
          <span class="range-label">Status</span>
          <div class="range-row">
            <mat-form-field appearance="outline" class="field">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status">
                <mat-option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="range-col">
          <span class="range-label">Data início</span>
          <div class="range-row">
            <mat-form-field appearance="outline" class="field">
              <mat-label>Data</mat-label>
              <input matInput [matDatepicker]="dp1" formControlName="dateStart">
              <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
              <mat-datepicker #dp1></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="range-col">
          <span class="range-label">Data fim</span>
          <div class="range-row">
            <mat-form-field appearance="outline" class="field">
              <mat-label>Data</mat-label>
              <input matInput [matDatepicker]="dp2" formControlName="dateEnd">
              <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
              <mat-datepicker #dp2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="filters-actions">
        <button mat-raised-button class="btn-primary button-login" type="submit">
          Aplicar filtros
        </button>
        <button mat-stroked-button type="button" (click)="resetFilters()">
          Limpar
        </button>
      </div>
    </form>

    <ng-container *ngIf="isLoading; else listTpl">
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
      </div>
    </ng-container>

    <ng-template #listTpl>
      <!-- header da lista -->
      <div class="list-header">
        <div class="col cover">Capa</div>
        <div class="col title">Título</div>
        <div class="col status">Status</div>
        <div class="col date">Data public.</div>
        <div class="col marketplace">Amazon</div>
        <div class="col actions">Ações</div>
      </div>

      <!-- itens -->
      <div class="group" *ngFor="let item of list; trackBy: trackByBook">
        <div class="version" *ngFor="let v of item.versions; trackBy: trackByVersion">
          <div class="col cover">
            <img [src]="v.coverUrl" alt="Capa do livro" (error)="onImgError($event)" />
          </div>

          <div class="col title">
            <div class="title-text">#{{ v.idBook }} - {{ v.title }}</div>
            {{ v.authorName }}
          </div>

          <div class="col status">
            <span class="chip"
                  [ngClass]="{
                    'chip-published': (v.status || '').toLowerCase().includes('publica'),
                    'chip-review': (v.status || '').toLowerCase().includes('revis'),
                    'chip-pending-approval': (v.status || '').toLowerCase().includes('aprova'),
                    'chip-payment': (v.status || '').toLowerCase().includes('pagamento'),
                    'chip-paused': (v.status || '').toLowerCase().includes('pausad'),
                    'chip-rejected': (v.status || '').toLowerCase().includes('reprov'),
                    'chip-edit': !(v.status || '')
                  }"
                  [matTooltip]="v.statusTooltip">
              {{ v.status }}
            </span>
          </div>

          <div class="col date">
            {{ v.date }}
          </div>

          <!-- Liberar publicação na Amazon -->
          <div class="col marketplace">
            <ng-container *ngIf="v.marketplace">
              <span [matTooltip]="marketplaceTooltip(v)">
                <mat-slide-toggle color="primary"
                                  [checked]="v.marketplace.isMarketplaceEnabled"
                                  [disabled]="isMarketplaceToggleDisabled(v)"
                                  (change)="onToggleMarketplace(v, $event)"
                                  [attr.aria-label]="'Liberar publicação na Amazon: ' + v.title">
                </mat-slide-toggle>
              </span>
              <span *ngIf="v.marketplace.listingStatusName" [ngClass]="marketplaceChipClass(v)">
                {{ v.marketplace.listingStatusName }}
              </span>
              <mat-progress-spinner *ngIf="togglingMarketplace.has(v.idBookVersion)" mode="indeterminate" diameter="16"></mat-progress-spinner>
            </ng-container>
          </div>

          <div class="col actions">
            <button mat-icon-button aria-label="Editar"
                    (click)="goTo(v.idBookVersion)"
                    [matTooltip]="'Editar livro'">
              <mat-icon style="color: rgb(12, 114, 12);">edit</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!list?.length" class="empty">
        Nenhum livro encontrado com os filtros atuais.
      </div>

      <!-- Paginação -->
      <div class="pagination" *ngIf="total > 0">
        <span class="pagination-info">
          {{ pageRangeStart }}–{{ pageRangeEnd }} de {{ total }} livros
        </span>
        <div class="pagination-controls">
          <button mat-icon-button [disabled]="page === 1" (click)="prevPage()" matTooltip="Página anterior">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="pagination-page">Página {{ page }} de {{ totalPages }}</span>
          <button mat-icon-button [disabled]="page >= totalPages" (click)="nextPage()" matTooltip="Próxima página">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>
